/** @jsx jsx */
import React, { useRef } from 'react';
import { css, jsx } from '@compiled/react';
import throttle from 'lodash/throttle';
import { WidthObserver } from '@atlaskit/width-detector';
import { ConsentBanner } from '@atlassian/browser-storage-controls';
import { ff } from '@atlassian/jira-feature-flagging';
import { MIN_BANNER_WIDTH } from '../../constants';
import {
	useCookieConsentBannerSettings,
	useCookieConsentBannerSettingsActions,
} from '../../services/preferences';

export const CookieConsentBanner = () => {
	const [{ height }] = useCookieConsentBannerSettings();
	const { onDismiss, setHeight } = useCookieConsentBannerSettingsActions();
	const ref = useRef<HTMLDivElement>(null);

	// banner height is set either due to screen width changes or consent banner finishes rendering
	const setBannerHeight = () => {
		ref.current && setHeight(ref.current.clientHeight);
	};

	// throttled banner height setter is used for dynamic banner height when screen width changes
	const throttledSetBannerHeight = throttle(setBannerHeight, 50);

	return (
		<>
			<WidthObserver setWidth={throttledSetBannerHeight} />
			<div
				ref={ref}
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
				css={css({
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
					...(!height && {
						visibility: 'hidden',
					}),
				})}
			>
				<ConsentBanner
					onHide={onDismiss}
					onShow={ff('jfp.magma.cookie-controls-banner-height-fix') ? setBannerHeight : undefined}
					minWidth={MIN_BANNER_WIDTH}
					product="Jira"
				/>
			</div>
		</>
	);
};
